<div class="fiche-repondant-create">
  <m-spinner
    v-if="isLoadingStateActive"
    :title="true"
    :description="true"
    :processing="true"
    :title-message="$i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.loading_overlay.title')"
    :description-message="$i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.loading_overlay.description')"
  />
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <template v-if="isSuccessStateActive">
      <div>
        <m-message
          class="fiche-repondant-create--success-message"
          :skin="MMessageSkin.Page"
          :title="$i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.message.create_success.title')"
        />
        <div class="fiche-repondant-create__footer">
          <m-button
            :skin="MButtonSkin.Secondary"
            @click="onReturnHomeButtonClick"
          >
            {{ $i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.button.return_home.label') }}
          </m-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <fiche-repondant-conditions-overlay />
        <fiche-repondant-available-cas-special
          class="fiche-repondant-create__cas-speciaux-disponible"
          :cas-speciaux="casSpeciauxDisponible"
        />
        <transition
          name="fade-fast"
          mode="out-in"
        >
          <template v-if="isFormDisplayed">
            <div>
              <fiche-repondant-form :ref="REF_FICHE_REPONDANT_FORM" />
              <div class="fiche-repondant-create__footer">
                <m-dialog
                  id="fiche-repondant-create__submit-dialog"
                  :width="MDialogWidth.Large"
                  :open="isSubmitDialogOpen"
                  :ok-label="$i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.dialog.submit_confirmation.submit_button')"
                  @ok="onDialogSubmitButtonClick"
                  @cancel="hideSubmitDialog"
                >
                  <p v-html="$i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.dialog.submit_confirmation.message')" />
                </m-dialog>
                <m-button @click="onSubmitButtonClick">
                  {{ $i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.button.submit.label') }}
                </m-button>
                <m-button
                  :skin="MButtonSkin.Secondary"
                  @click="onReturnHomeButtonClick"
                >
                  {{ $i18next.t('modules.fiche-repondant.create.FicheRepondantCreate.button.return_home.label') }}
                </m-button>
              </div>
            </div>
          </template>
        </transition>
      </div>
    </template>
  </transition>
</div>